/** @format */
import { AccordionModule } from '@shared/components';
import { CommonModule } from '@angular/common';
import { HomrRichContentComponent } from './homr-rich-content.component';
import { HtmlSanitizerPipe } from '@shared/utils/pipes';
import { MediaModule } from '@shared/media/components';
import { NgModule } from '@angular/core';
import { TechIconsModule } from './tech-icons/tech-icons.module';
import { TrendingComponent } from './trending/trending.component';

@NgModule({
	declarations: [HomrRichContentComponent],
	imports: [
		AccordionModule,
		CommonModule,
		HtmlSanitizerPipe,
		MediaModule,
		TechIconsModule,
		TrendingComponent
	],
	exports: [HomrRichContentComponent, TrendingComponent]
})
export class HomrRichContentModule {}
